import { ContactSubject } from "@upsquad/shared";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CONTACT_ROUTES } from "@/src/contact/constants/contact-routes";
import { CtaLink } from "../atoms/cta-link";

interface LandingAccountDeletionSectionProps {
	communityName: string;
}

export function LandingAccountDeletionSection({ communityName }: LandingAccountDeletionSectionProps) {
	const { t } = useTranslation("community");

	return (
		<section className="bg-background py-16 md:py-20">
			<div className="mx-auto w-full max-w-4xl px-6">
				<div className="flex flex-col items-start gap-5 rounded-2xl border border-divider bg-content2/50 p-8 md:flex-row md:items-center md:justify-between">
					<div className="flex items-start gap-4">
						<div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-danger/10 text-danger">
							<Trash2 className="h-5 w-5" />
						</div>
						<div className="flex flex-col gap-2">
							<h3 className="text-lg font-semibold text-foreground">{t("landing.account_deletion.title")}</h3>
							<p className="text-sm leading-relaxed text-foreground/60">{t("landing.account_deletion.description", { communityName })}</p>
						</div>
					</div>
					<CtaLink
						to={`${CONTACT_ROUTES.CONTACT}?subject=${ContactSubject.ACCOUNT_REMOVAL}`}
						variant="outline"
						size="md"
						className="shrink-0"
					>
						{t("landing.account_deletion.cta")}
					</CtaLink>
				</div>
			</div>
		</section>
	);
}
